import RecordRTC, { StereoAudioRecorder } from "recordrtc";

const init = async ({
  socketIOSocket,
  onMessage,
  apiCallPost,
  onOpen,
  stream,
}) => {
  // get aai token
  try {
    const res = await apiCallPost("/harley/getAaiToken", {});
    if (res.token) {
      // establish wss with AssemblyAI at 16000 sample rate
      let aaiSocket = new WebSocket(
        `wss://api.assemblyai.com/v2/realtime/ws?sample_rate=16000&token=${res.token}`
      );

      // handle incoming messages to display transcription to the DOM
      const texts = {};
      aaiSocket.onmessage = (message) => {
        let msg = "";
        const res = JSON.parse(message.data);
        // console.log(res);
        texts[res.audio_start] = res.text;
        const keys = Object.keys(texts);
        keys.sort((a, b) => a - b);
        for (const key of keys) {
          if (texts[key]) {
            msg += ` ${texts[key]}`;
          }
        }
        if (res.message_type === "FinalTranscript") {
          socketIOSocket.emit(
            "send hume",
            JSON.stringify({
              models: {
                language: {
                  granularity: "passage",
                },
              },
              raw_text: true,
              data: res.text,
            })
          );
        }
        onMessage(msg);
        // messageEl.innerText = msg;
      };

      // handle error
      aaiSocket.onerror = (event) => {
        console.error(event);
        aaiSocket.close();
      };

      // handle socket close
      aaiSocket.onclose = (event) => {
        console.log(event);
        aaiSocket = null;
      };

      aaiSocket.onopen = () => {
        const recorder = new RecordRTC(stream, {
          type: "audio",
          mimeType: "audio/webm;codecs=pcm", // endpoint requires 16bit PCM audio
          recorderType: StereoAudioRecorder,
          timeSlice: 250, // set 250 ms intervals of data
          desiredSampRate: 16000,
          numberOfAudioChannels: 1, // real-time requires only one channel
          bufferSize: 4096,
          audioBitsPerSecond: 128000,
          ondataavailable: (blob) => {
            const reader = new FileReader();
            reader.onload = () => {
              const base64data = reader.result;

              // audio data must be sent as a base64 encoded string
              if (aaiSocket) {
                aaiSocket.send(
                  JSON.stringify({
                    audio_data: base64data.split("base64,")[1],
                  })
                );
              }
            };
            reader.readAsDataURL(blob);
          },
        });

        recorder.startRecording();
        onOpen();
      };

      console.log("return aaisocket", { aaiSocket });
      return aaiSocket;
    }
  } catch (error) {
    console.error("could not get aai token", error);
  }
};

export default init;
